import React, { useEffect, useState } from 'react'
import Style from './Perks.css'
import numOne from '../../assets/shape-1.svg'
import numTwo from '../../assets/shape-2.svg'
import numThree from '../../assets/shape-3.svg'
import numFour from '../../assets/shape-4.svg'
import perks from '../../assets/perks.jpg'
import Button from '../Button'

const Perks = (props) => {
  const [type, setType] = useState('National Merit Scholarship')
  useEffect(() => {
    let url = window.location.toString()
    let awardType = url.split('/awards/')
    if (awardType.length > 1) {
      if (awardType[1] === 'azmerit' || awardType[1] === 'merit') {
        setType('National Merit Semifinalist')
      }
    }
  })
  return (
    <section className={`perks ${props.show}`}>
      <div className="container">
        <h2>Perks of Being a Wildcat Scholar</h2>
        <div className="perksImage">
          <div className="flex-basis-full pr-12">
            <p className="psuedo-before-color-arizona-red perksHeading">
              Thanks to your {type} status, you’ll be automatically admitted* to the prestigious{' '}
              <a
                id="franke-honors-college"
                className="blueBrand"
                target="_blank"
                href="https://frankehonors.arizona.edu/"
              >
                W.A. Franke Honors College
              </a>{' '}
              and enjoy the very best of everything our campus has to offer.
            </p>
            <p>
              You’ll love being a valued member of our close-knit honors community and having access
              to the state-of-the-art{' '}
              <a
                id="honors-village"
                target="_blank"
                href="https://frankehonors.arizona.edu/student-experience/honors-village"
                className="blueBrand font-normal"
              >
                Honors Village{' '}
              </a>
              while plugging into the vast student resources at our premier research university.
            </p>
            <p>
              Use your talents{' '}
              <a
                id="working-alongside-researchers"
                target="_blank"
                href="https://frankehonors.arizona.edu/academics/research"
                className="blueBrand font-normal"
              >
                working alongside researchers
              </a>
              , studying abroad, participating in internships, giving back to the community – or all
              of the above. The possibilities are yours to define.
            </p>
            <p className="italic">
              *Complete your University of Arizona undergraduate application to be automatically
              admitted to the W.A. Franke Honors College.
            </p>
          </div>
          <div className="">
            {' '}
            <img src={perks} alt="Students sitting outside" />
          </div>
        </div>

        <div className="perks-container">
          <div className="perks-wrap flex-basis50">
            <div className="perk-wrap">
              <img src={numOne} alt="perk 1" />
              <div className="pad-10-t">
                <span>
                  <b>$955 million</b>
                  <br />
                  annual research expenditures
                </span>
              </div>
            </div>
            <div className="perk-wrap">
              <img src={numTwo} alt="perk 2" />
              <div className="pad-10-t">
                <span>
                  <b>250+</b> <br /> honors-specific courses
                </span>
              </div>
            </div>
          </div>
          <div className="perks-wrap">
            <div className="perk-wrap">
              <img src={numThree} alt="perk 3" />
              <div className="pad-10-t">
                <span>
                  <b>100+</b> <br />
                  faculty & staff dedicated to honors students
                </span>
              </div>
            </div>
            <div className="perk-wrap">
              <img src={numFour} alt="perk 4" />
              <div className="pad-10-t">
                <span>
                  Tap into honors-specific clubs, programs, trips, funding, & other opportunities
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="button-container">
          <Button
            linkId="view-scholar-experience"
            link="https://frankehonors.arizona.edu/why-honors/national-merit-scholars"
          >
            Your Scholar Experience
          </Button>

          <p className="italic">
            What’s it really like to be a Franke Honors Wildcat?{' '}
            <a
              id="ditl-video-playlist"
              className="blueBrand font-normal"
              target="_blank"
              href="https://www.youtube.com/playlist?list=PLMrsYOKrP2J-V3MG4acBPhA4--r34_xWo"
            >
              Check out our #DITL video playlist
            </a>
            .
          </p>
        </div>

        {/* <TwoCol direction="reverse">
                    <div className="first">
                        <img src={perkStudy} alt="University of Arizona Professor working with students at Honors Village." />
                    </div>
                    <div className='content second'>
                    <h3>From the Moment You Arrive On Campus</h3>
                    You have an opportunity to make an immediate impact with a <strong>First Year Project</strong>, which allows you to partake in research during the second semester of your first year on a topic or interest that matters to you, with guidance from a faculty mentor. Make a difference, no matter your field of study.
                    </div>
                </TwoCol>
                <TwoCol direction="forward">
                    <div className="first">
                        <img src={perkFaculty} alt="University of Arizona Faculty working with student at Honors Village." />
                    </div>
                    <div className='content second'>
                        And that’s just the beginning. Throughout your time at the University of Arizona, you’ll receive support from more than 100 distinguished faculty and staff dedicated to honors students.
                    </div>
                </TwoCol>
                <TwoCol direction="reverse">
                    <div className="first">
                        <img src={perkVillage} alt="Outside front view of the Honors Village at the University of Arizona." />
                    </div>
                    <div className='content second'>
                    <h3>The Honors Village</h3>
                        Designed to empower your potential, the <a href="https://housing.arizona.edu/dorms/honors-village" target="_blank" rel="noopener" className="font-color-arizona-red" id="honors-village">Honors Village</a> is a living and learning community built to elevate every aspect of your life. Enjoy contemporary dorm or apartment spaces and exclusive amenities.
                    </div>
                </TwoCol>
                <TwoCol direction="forward">
                    <div className="first">
                        <img src={perkRec} alt="Honors students exercising at the Honors Village recreation center." />
                    </div>
                    <div className='content second'>
                        <ul className='perk-summary'>
                            <li>
                                <img src={numOne} alt="perk one"/>
                                <span>On-site honors classrooms</span>
                            </li>
                            <li>
                                <img src={numTwo} alt="perk two"/>
                                <span>Honors-only professional development and faculty-led workshops</span>
                            </li>
                            <li>
                                <img src={numThree} alt="perk three"/>
                                <span>A brand-new recreation center just steps outside your front door</span>
                            </li>
                        </ul>
                    </div>
                </TwoCol> */}
      </div>
    </section>
  )
}
export default Perks
